export const ACTION_TYPES = {
  SET_LOCALE: 'locale/SET_LOCALE'
};
